// extracted by mini-css-extract-plugin
export default {"backButton":"ReservationsPage_backButton__lq6P4","nameContainer":"ReservationsPage_nameContainer__AKSZv","paperContainer":"ReservationsPage_paperContainer__8n3Bp"};